// extracted by mini-css-extract-plugin
export var content = "_6r-3";
export var list = "_6r-4";
export var settingsContent = "_6r-7";
export var settingsPanel = "_6r-8";
export var state = "_6r-6";
export var triggerBadge = "_6r-2";
export var triggerButton = "_6r-1";
export var triggerShell = "_6r-0";
export var unreadDot = "_6r-5";